// extracted by mini-css-extract-plugin
module.exports = {"collectionTitle":"detail-collection-header_collectionTitle__H_FjF","headerImageContent":"detail-collection-header_headerImageContent__e0AFm"};